module.exports = __webpack_public_path__ + "static/img/pc-img3.67b8b43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/519celebrate/pc-img3.jpg
// module id = RXCQ
// module chunks = 0